<template>
  <section class="inner-page">
    <h4>Percursos Guardados</h4>
    <div>
      <section class="percursos-container" v-if="paths">
        <article class="percurso" v-for="path in paths" :key="path.id">
            <img src="@/assets/textura-elvas-branco@3x.png">
          <div class="percurso-content">
            <h3>{{path.translation.title}}</h3>
            <p class="type">{{path.translation.type}}</p>
            <p class="description">{{path.translation.description}}</p>
            <router-link :to="'/percurso/' + path.id">
              <elvasButton :button="{title: 'VER PERCURSO'}"></elvasButton>
            </router-link>
          </div>
        </article>
      </section>
      <section>
        <h5>Não tem percursos guardados</h5>
      </section>
    </div>
  </section>
</template>
<script>
export default {
  name: 'percursos',
  props: [],
  components: {
  },
  data() {
    return {
      paths: []
    }
  },
  async mounted () {
    let data = await this.api.get('/path?user_id=' + this.$store.state.user.id)
    if (data) {
      this.paths = data
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
h1 {
  font-size: 80px;
  display: table;
}
h5 {
  font-size: 24px;
  color: #b0916b;
  font-weight: bold;
}
.percursos-container {
  width: 100%;
  margin-top: 48px;
  position: relative;
  z-index: 5;
  .percurso {
    text-align: center;
    background: #eee3d4;
    display: flex;
    margin-bottom: 50px;
    padding: 50px 0;
    overflow: hidden;
    position: relative;
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .percurso-content {
      margin: auto;
      position: relative;
      h3 {
        font-weight: bold;
        font-size: 32px;
        color: #a79374;
      }
      .type {
        margin: 24px 0 26px 0;
        font-size: 16px;
        line-height: 1.5;
        text-align: center;
        color: #a79374;
      }
      p {
        margin-top: 20px;
        padding: 0 50px;
        line-height: 1.56;
        letter-spacing: -0.4px;
        text-align: center; 
        font-size: 18px;
      }
      .elvas-button {
        margin-top: 25px;
      }
    }
  }
}
</style>